var _path, _path2, _g, _path3, _path4, _g2, _path5, _path6, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoxOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.332 14.326C46.576 14.326 54 22.684 54 31.96c0 2.963-.864 6.013-2.38 8.799-.283.458-.318 1.04-.124 1.587l1.181 3.95c.265.952-.546 1.657-1.446 1.375l-3.561-1.058c-.97-.317-1.728.088-2.63.635-2.574 1.516-5.781 2.292-8.673 2.292-8.746 0-17.633-6.753-17.633-17.633 0-9.38 7.582-17.58 17.598-17.58z",
    fill: "url(#23porrsmha)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "d7mueu5jxb",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 14,
    width: 36,
    height: 36
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.332 14.326C46.576 14.326 54 22.684 54 31.96c0 2.963-.864 6.013-2.38 8.799-.283.458-.318 1.04-.124 1.587l1.181 3.95c.265.952-.546 1.657-1.446 1.375l-3.561-1.058c-.97-.317-1.728.088-2.63.635-2.574 1.516-5.781 2.292-8.673 2.292-8.746 0-17.633-6.753-17.633-17.633 0-9.38 7.582-17.58 17.598-17.58z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#d7mueu5jxb)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#0be1igcwyc)",
    d: "M18 13.5h36V54H18z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.096.551C10.023.551.55 11.216.55 23.051c0 3.78 1.102 7.673 3.037 11.228.36.584.405 1.327.158 2.024l-1.508 5.04c-.337 1.215.698 2.115 1.845 1.755l4.545-1.35c1.238-.404 2.205.113 3.355.81 3.285 1.935 7.378 2.925 11.068 2.925 11.16 0 22.5-8.617 22.5-22.5 0-11.97-9.675-22.432-22.455-22.432z",
    fill: "url(#k3map52xnd)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "bgmlx87yae",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 46,
    height: 46
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.096.551C10.023.551.55 11.216.55 23.051c0 3.78 1.102 7.673 3.037 11.228.36.584.405 1.327.158 2.024l-1.508 5.04c-.337 1.215.698 2.115 1.845 1.755l4.545-1.35c1.238-.404 2.205.113 3.355.81 3.285 1.935 7.378 2.925 11.068 2.925 11.16 0 22.5-8.617 22.5-22.5 0-11.97-9.675-22.432-22.455-22.432z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bgmlx87yae)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#2dirkk1c0f)",
    d: "M-1.303-1.066h47.25v47.25h-47.25z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.007 25.953a2.905 2.905 0 0 1-2.88-2.902c0-1.575 1.305-2.88 2.88-2.858a2.871 2.871 0 0 1 2.88 2.88 2.886 2.886 0 0 1-2.88 2.88zm-10.373 0a2.9 2.9 0 0 1-2.88-2.88 2.871 2.871 0 0 1 2.88-2.88 2.871 2.871 0 0 1 2.88 2.88c0 1.575-1.283 2.858-2.88 2.88zm17.865-2.88a2.886 2.886 0 0 0 2.88 2.88 2.886 2.886 0 0 0 2.88-2.88 2.871 2.871 0 0 0-2.88-2.88 2.871 2.871 0 0 0-2.88 2.88z",
    fill: "url(#3l9etboyfg)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "pnvoesfj2h",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 20,
    width: 28,
    height: 6
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.007 25.953a2.905 2.905 0 0 1-2.88-2.902c0-1.575 1.305-2.88 2.88-2.858a2.871 2.871 0 0 1 2.88 2.88 2.886 2.886 0 0 1-2.88 2.88zm-10.373 0a2.9 2.9 0 0 1-2.88-2.88 2.871 2.871 0 0 1 2.88-2.88 2.871 2.871 0 0 1 2.88 2.88c0 1.575-1.283 2.858-2.88 2.88zm17.865-2.88a2.886 2.886 0 0 0 2.88 2.88 2.886 2.886 0 0 0 2.88-2.88 2.871 2.871 0 0 0-2.88-2.88 2.871 2.871 0 0 0-2.88 2.88z",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#pnvoesfj2h)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#bi2v2ja2ni)",
    d: "M9 13.5h29.25v18H9z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "23porrsmha",
    x1: 18.734,
    y1: 14.326,
    x2: 18.734,
    y2: 49.539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7CC1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#468DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "0be1igcwyc",
    x1: 18,
    y1: 13.5,
    x2: 18,
    y2: 54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0084E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004CC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k3map52xnd",
    x1: 0.551,
    y1: 0.551,
    x2: 0.551,
    y2: 45.483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "2dirkk1c0f",
    x1: -1.303,
    y1: -1.066,
    x2: -1.303,
    y2: 46.184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7D9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "3l9etboyfg",
    x1: 9.754,
    y1: 20.193,
    x2: 9.754,
    y2: 25.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7CC1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#468DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bi2v2ja2ni",
    x1: 9,
    y1: 13.5,
    x2: 9,
    y2: 31.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0084E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004CC4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxOutline);
export default __webpack_public_path__ + "static/media/box_outline.aaec3ba0.svg";
export { ForwardRef as ReactComponent };